import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'home' */ './views/Home.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {public: true},
      component: () => import(/* webpackChunkName: 'login' */ './views/Login.vue')
    },
    {
      path: '/invitations/:id/edit',
      name: 'invitation',
      meta: {public: true},
      component: () => import(/* webpackChunkName: 'invitations' */ './views/Invitation.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {public: true},
      component: () => import(/* webpackChunkName: 'register' */ './views/Register.vue')
    },
    {
      path: '/contacts',
      name: 'contactIndex',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'contactIndex' */ './views/ContactIndex.vue')
    },
    {
      path: '/contacts/:id',
      name: 'contact_folders',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'contactShow' */ './views/ContactFolders.vue'),
      props: true,
    },
    {
      path: '/contacts/:id/communication',
      name: 'contact_communications',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'contactShow' */ './views/ContactCommunications.vue'),
      props: true,
    },
    {
      path: '/contacts/:id/file-communication',
      name: 'contact_interactive_notes',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'contactShow' */ './views/ContactRecordMessage.vue'),
      props: true,
    },
    {
      path: '/contacts/:id/emails',
      name: 'contact_emails',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'contactShow' */ './views/ContactEmails.vue'),
      props: true,
    },
    {
      path: '/folders',
      name: 'folders',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'folders' */ './views/RootFolder.vue')
    },
    {
      path: '/folders/checklist',
      name: 'root_folders_checklist',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'folders' */ './views/RootFolderChecklist.vue')
    },
    {
      path: '/folders/:id',
      name: 'folder',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'folder' */ './views/FolderShow.vue'),
      props: true,
    },
    {
      path: '/folders/:id/checklist',
      name: 'folder_checklist',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'folder' */ './views/FolderChecklist.vue'),
      props: true,
    },
    {
      path: '/folders/:id/activity',
      name: 'folder_activity',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'folder' */ './views/FolderActivity.vue'),
      props: true,
    },
    {
      path: '/records/:id',
      name: 'record',
      component: () => import(/* webpackChunkName: 'record' */ './views/Record.vue'),
      props: ({params, hash}) => ({ id: params.id, referrer: params.referrer, propRecords: params.propRecords, hash: hash })
    },
    {
      path: '/records',
      name: 'records',
      meta: {layout: 'application'},
      props: (route) => ({ query: route.query }),
      component: () => import(/* webpackChunkName: 'records' */ './views/Records.vue'),
    },
    {
      path: '/shared_folders',
      name: 'shared_folder_index',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'shared_folder_index' */ './views/SharedFolderIndexTemp.vue'),
      props: ({query}) => ({ q: query })
    },
    {
      path: '/shared_folders/checklist',
      name: 'shared_folder_index_checklist',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'shared_folder_checklist' */ './views/SharedFolderIndexChecklist.vue'),
      props: ({query}) => ({ q: query })
    },
    {
      path: '/shared_folders/:id',
      name: 'shared_folder_show',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'shared_folder_show' */ './views/SharedFolderShow.vue'),
    },
    {
      path: '/shared_folders/:id/checklist',
      name: 'shared_folder_checklist',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'shared_folder_show' */ './views/SharedFolderChecklist.vue'),
    },
    {
      path: '/shared_records/:id',
      name: 'shared_record_show',
      component: () => import(/* webpackChunkName: 'shared_record_show' */ './views/SharedRecordShow.vue'),
      props: ({params, hash}) => ({ id: params.id, referrer: params.referrer, propRecords: params.propRecords, hash: hash })
    },
    {
      path: '/records/:record_id/versions/:id',
      name: 'record_show_versioned',
      component: () => import(/* webpackChunkName: 'shared_record_show' */ './views/RecordShowVersioned.vue'),
      props: ({params, hash}) => ({ id: params.id, referrer: params.referrer, recordId: params.record_id, hash: hash })
    },
    {
      path: '/deleted',
      name: 'deleted',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'deleted' */ './views/Deleted.vue'),
    },
    {
      path: '/deleted/:id',
      name: 'deleted_show',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'deleted_show' */ './views/DeletedShow.vue'),
      props: true,
    },
    {
      path: '/products',
      name: 'products',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'products' */ './views/Products.vue')
    },
    {
      path: '/products/archived',
      name: 'archived_products',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'products' */ './views/Products.vue'),
      props: () => ({ activeTab: 'archived' })
    },
    {
      path: '/products/:id',
      name: 'product',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'products' */ './views/Product.vue')
    },
    {
      path: '/tags',
      name: 'tags',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'tags' */ './views/Tags.vue')
    },
    {
      path: '/tags/:id',
      name: 'tag',
      meta: {layout: 'application'},
      component: () => import(/* webpackChunkName: 'tag' */ './views/Tag.vue')
    },
    {
      path: '/document_types',
      name: 'document_types',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'document-types' */ './views/DocumentTypes.vue')
    },
    {
      path: '/document_types/archived',
      name: 'archived_document_types',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'document-types' */ './views/DocumentTypes.vue'),
      props: () => ({ activeTab: 'archived' })
    },
    {
      path: '/document_types/:id',
      name: 'document_type',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'document-type' */ './views/DocumentType.vue')
    },
    {
      path: '/notifications',
      name: 'notifications',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'notifications' */ './views/Notifications.vue')
    },
    {
      path: '/account_settings',
      name: 'account_settings',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'settings' */ './views/AccountSettings.vue')
    },
    {
      path: '/calendar',
      name: 'calendar',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'calendar' */ './views/Calendar.vue'),
      props: () => ({ events: '/calendar/events', upcoming: '/calendar/upcoming' })
    },
    {
      path: '/public/version_requests/:uuid',
      name: 'public_version_request',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_version_request' */ './views/public/VersionRequest.vue'),
    },
    {
      path: '/public/folders/:uuid',
      name: 'public_folder',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_folder' */ './views/public/Folder.vue')
    },
    {
      path: '/public/shared_folders/:uuid',
      name: 'public_shared_folder_show',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_shared_folder_show' */ './views/public/SharedFolderShow.vue')
    },
    {
      path: '/public/shared/records/:uuid',
      name: 'public_shared_record_show',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'public_shared_folder_show' */ './views/public/SharedRecordShow.vue')
    },
    {
      path: '/public/expiration_pages/:uuid',
      name: 'public_expiration_page',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_expiration_page' */ './views/public/ExpirationPage.vue')
    },
    {
      path: '/public/record_message_sents/:uuid',
      name: 'public_record_message_sents',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_record_message_sent' */ './views/public/RecordMessageSent.vue')
    },
    {
      path: '/public/contact_pages/:uuid',
      name: 'public_contact_page',
      meta: { layout: 'public', public: true },
      component: () => import(/* webpackChunkName: 'public_contact_page' */ './views/public/ContactPage.vue')
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'login' */ './views/ResetPassword.vue')
    },
    {
      path: '/new_password/:token',
      name: 'new_password',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'register' */ './views/NewPassword.vue')
    },
    {
      path: '/public/verify_accounts/:token',
      name: 'public_verify_accounts',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'verify_account' */ './views/VerifyAccount.vue')
    },
    {
      path: '/search_results',
      name: 'search_results',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'search_result' */ './views/SearchResult.vue')
    },
    {
      path: '/login_as',
      name: 'login_as',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'invitations' */ './views/admin/LoginAs.vue')
    },
    {
      path: '/communication/inbox',
      name: 'inbox',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_inbox' */ './views/communication/Inbox.vue')
    },
    {
      path: '/communication/records/messages',
      name: 'record_message',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_records' */ './views/communication/RecordMessage.vue')
    },
    {
      path: '/communication/records/messages/:id',
      name: 'record_message_show',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_sent' */ './views/communication/RecordMessageShow.vue'),
      props: ({params, hash}) => ({id: params.id, referrer: params.referrer, messageType: params.messageType, hash: hash })
    },
    {
      path: '/communication/sent',
      name: 'sent',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_sent' */ './views/communication/Sent.vue')
    },
    {
      path: '/communication/attachments',
      name: 'attachments',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_attachments' */ './views/communication/Attachments.vue')
    },
    {
      path: '/communication/automated-emails',
      name: 'automated-emails',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_automated_emails' */ './views/communication/AutomatedEmails.vue')
    },
    {
      path: '/communication/future-emails',
      name: 'future-emails',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_future_emails' */ './views/communication/FutureEmails.vue')
    },
    {
      path: '/communication/trash',
      name: 'trash',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_trash' */ './views/communication/Trash.vue')
    },
    {
      path: '/communication/message/:id/:messageType',
      name: 'message',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'communication_trash' */ './views/communication/MessageShow.vue'),
      props: ({params, hash}) => ({id: params.id, referrer: params.referrer, messageType: params.messageType, hash: hash })
    },
    {
      path: '/my_shared_folders',
      name: 'my_shared_folders_index',
      meta: { layout: 'application' },
      component: () => import(/* webpackChunkName: 'my_shared_folders_index' */ './views/MySharedFolders.vue')
    },
    {
      path: '/msoffice',
      name: 'msoffice_home',
      meta: { outlook: true, public: false, layout: 'outlook' },
      component: () => import(/* webpackChunkName: 'msoffice-home' */ './views/msoffice/Home.vue')
    },
    {
      path: '/msoffice/login',
      name: 'msoffice_login',
      meta: { outlook: true, public: false, layout: 'outlook' },
      component: () => import(/* webpackChunkName: 'msoffice-login' */ './views/msoffice/Login.vue')
    },
    {
      path: '/msoffice/outlook/reader',
      name: 'outlook_taskpane_reader',
      meta: { outlook: true, public: false, layout: 'outlook' },
      component: () => import(/* webpackChunkName: 'msoffice-outlook-reader' */ './views/msoffice/outlook/TaskpaneReader.vue')
    },
    {
      path: '/msoffice/outlook/writer',
      name: 'outlook_taskpane_writer',
      meta: { outlook: true, public: false, layout: 'outlook' },
      component: () => import(/* webpackChunkName: 'msoffice-outlook-writer' */ './views/msoffice/outlook/TaskpaneWriter.vue')
    },
    {
      path: '*',
      name: '404',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'notfound' */ './views/404.vue')
    },
    {
      path: '/unsupported_browser',
      name: 'unsupported_browser',
      meta: { public: true },
      component: () => import(/* webpackChunkName: 'browsers' */ './views/UnsupportedBrowser.vue')
    },
  ]
})
